import MASTER_TYPE_CONFIG from '../../common/masterTypeConfig';


export const CONTRACT_MANAGEMENT_MASTERS = [
  { label: 'RFQ Settings', value: MASTER_TYPE_CONFIG.RFQ_SETTINGS },
  { label: 'Product Category', value: MASTER_TYPE_CONFIG.PRODUCT_CATEGORY },
  { label: 'Packaging Type', value: MASTER_TYPE_CONFIG.PACKAGING_TYPE },
  { label: 'Pricing Basis', value: MASTER_TYPE_CONFIG.PRICING_BASIS },
  { label: 'Vehicle Type', value: MASTER_TYPE_CONFIG.CONTRACT_VEHICLE_TYPE },
  { label: 'Vehicle Body Type', value: MASTER_TYPE_CONFIG.VEHICLE_BODY },
  { label: 'UOM', value: MASTER_TYPE_CONFIG.UOM },
  { label: 'Loadability', value: MASTER_TYPE_CONFIG.LOADABILITY },
  { label: 'Vehicle Details', value: MASTER_TYPE_CONFIG.VEHICLE_DETAILS },
  { label: 'Currency Converter', value: MASTER_TYPE_CONFIG.CURRENCY },
  { label: 'Auto Bid Decrement Range', value: MASTER_TYPE_CONFIG.AUTO_DECREMENT },
];

export const isContractManagementMaster = (masterType) =>
  CONTRACT_MANAGEMENT_MASTERS.some(master => master.value === +masterType);
